import { BasicInputComponent } from "../interfaces/basic-input-component";
import { FormBuilderEditorConfigurationModel } from "./form-builder-editor-configuration-model";
import { BlurEvent, ChangeEvent } from "@ckeditor/ckeditor5-angular";

export class FormBuilderBasicInputComponentModel implements BasicInputComponent {
    public data: any;

    public editorConfig: FormBuilderEditorConfigurationModel = new FormBuilderEditorConfigurationModel();

    get label(): string {
        return this.data.component.label;
    }

    get placeholder(): string {
        return this.data.component.placeholder;
    }

    get content(): string {
        return this.data.component.content;
    }

    get mandatory(): boolean {
        return this.data.component.mandatory;
    }

    get help(): string {
        return this.data.component.help;
    }

    get viewType(): string {
        return this.data.viewType;
    }

    get toggleTooltips(): boolean {
        return this.data.toggleTooltips;
    }

    init(): void {
        if (this.data.component.content !== 'rich_text') {
            this.data.editorData = this.data.component.content;
        }
    }

    handleEditorChange({ editor }: ChangeEvent): void {
        this.data.hasChanges = true;
    }

    handleEditorBlur({ editor }: BlurEvent): void {
        const data = editor.getData();

        if (data.toString().trim() === '') {
            this.data.hasChanges = true;

            this.data.editorData = 'rich_text';
            this.data.editorActive = false;
        }
    }

    handleEditorToggleClick(event?: MouseEvent): void {
        if (event) {
            event.preventDefault();
        }

        if (this.data.viewType !== 'default') {
            return;
        }

        if (this.data.editorData === 'rich_text') {
            this.data.editorData = '';
        }

        this.data.editorActive = true;
    }

    showRichTextRenderer(): boolean {
        if (this.data.component.content === 'rich_text' || this.data.editorActive === true) {
            return this.data.viewType !== 'default';
        }

        return true;
    }
}
